import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useTranslation } from "react-i18next";

export function IntegrationsHeader() {
  const { t } = useTranslation();

  return (
    <Card className="bg-transparent border-0 shadow-none">
      <CardHeader className="p-0 pb-6">
        <div>
          <CardTitle className="text-3xl font-bold">
            {t("team.integrations.title")}
          </CardTitle>
          <CardDescription className="mt-2 text-base">
            {t("team.integrations.description")}
          </CardDescription>
        </div>
      </CardHeader>
    </Card>
  );
}
